export default {"src":"/_next/static/media/Unread.f268b88e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};